/**
 * Parses contentful rich text node into a JSON object safely
 */
const parseRichText = (string) => {
  try {
    const richTextJson = JSON.parse(string);
    return richTextJson; 
  } catch (e) {
    return null;
  }
}

export default parseRichText;